import { cn } from './cn';

/** Whether the live updates (WebSocket) are coming in. */
export function LiveStatus({ connected }: { connected: boolean }) {
  return (
    <output
      className={cn(
        'inline-flex items-center gap-2 text-label font-semibold',
        connected ? 'text-success' : 'text-warning',
      )}
    >
      <span aria-hidden="true" className="size-2 rounded-full bg-current" />
      {connected ? 'Live' : 'Reconnecting…'}
    </output>
  );
}
